<template>
    <b-tab title-link-class="p-0" lazy>
        <template v-slot:title>
            <b-nav-item-dropdown>
                <template slot="button-content">
                    <i class="cus-comments"></i>
                    Communications
                </template>

                <b-dropdown-item @click="displayList">
                    <i class="cus-comments"></i>View Communications
                </b-dropdown-item>

                <div class="dropdown-divider"></div>

                <b-dropdown-item
                    @click.stop="openModal('modalLogCommunication')"
                >
                    <i class="cus-add"></i> Log Communication
                </b-dropdown-item>

                <div class="dropdown-divider"></div>

                <b-dropdown-item @click.stop="openModal('modalSendEmail')">
                    <i class="cus-email"></i>Send Email
                </b-dropdown-item>

                <b-dropdown-item
                    v-if="
                        (_isExtensionEnabled(EXTENSIONS.CODE.CODE_SMS) ||
                            _isExtensionEnabled(
                                EXTENSIONS.CODE.CODE_2_WAY_MESSAGING
                            )) &&
                        !isCompany
                    "
                    @click.stop="openModal('modalSendSms')"
                >
                    <i class="cus-phone"></i>Send SMS
                </b-dropdown-item>
            </b-nav-item-dropdown>
        </template>
        <b-card-text>
            <communication-list :key="keyview" />
        </b-card-text>
    </b-tab>
</template>

<script>
import EXTENSIONS from "@/constants/extensions";
import communicationList from "@/module/contact/tabs/communication-list";

export default {
    components: {
        communicationList
    },
    data() {
        return {
            keyview: 0,
            EXTENSIONS
        };
    },
    computed: {
        isCompany() {
            return this.$route.name === "contact_company";
        }
    },
    methods: {
        displayList() {
            this.keyview += 1;
        },
        openModal(ref) {
            this.$root.$emit("open-modal-contact", ref);
        }
    }
};
</script>
